import { useDispatch, useSelector } from '../../../../../store/store';
import { PaymentMethod } from '../../../../../store/workspace/types';
import { setNotification } from '../../../../../store/general/slice';
import CheckBox from '../../../../../components/CheckBox';
import Spinner from '../../../../../components/Spinner';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    PlusIcon,
    CreditCardIcon,
    SquareCheckIcon,
} from '../../../../../assets/icons';
import {
    setAddNewCardModal,
    setExtraServicesPaymentModal,
} from '../../../../../store/workspace/slice';
import {
    getProfileDataThunk,
    paymentThunk,
} from '../../../../../store/workspace/thunks';
import {
    selectFetchingpPaymentMethods,
    selectExtraServiceDetail,
} from '../../../../../store/workspace/selectors';
import { xhrDefaultMessage } from '../../../../../configs/notification';

export default function ExtraServicesPayment() {
    const dispatch = useDispatch();
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
    const [submitingPayment, setSubmitingPayment] = useState(false);
    const serviceDetail = useSelector(selectExtraServiceDetail);
    const [errorMessage, setErrorMessage] = useState('');
    // const fetchingPaymentMethods = useSelector(selectFetchingpPaymentMethods);
    const [fetching, setFetching] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState<PaymentMethod | null>(null);
    const [step, setStep] = useState<'SelectPaymentMethod' | 'Done'>('SelectPaymentMethod');

    useEffect(() => {
        setFetching(true);
        dispatch(paymentThunk({
            action: 'get_payment_methods',
        }))
            .unwrap()
            .then(response => {
                setPaymentMethods(response)
            })
            .catch(e => {
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
            .finally(() => {
                setFetching(false);
            })
    }, []);

    const next = () => {
        switch (step) {
            case 'SelectPaymentMethod':
                submitPayment();
                break;
            case 'Done':
                dispatch(setExtraServicesPaymentModal(false));
                break;
            default:
                return;
        }
    };

    const submitPayment = () => {
        if (!serviceDetail || !selectedMethod) return;

        setErrorMessage('');
        setSubmitingPayment(true);

        dispatch(paymentThunk({
            action: 'add_payment',
            add: serviceDetail.type,
            sub: serviceDetail.sub,
            pmId: selectedMethod.id,
        }))
            .unwrap()
            .then(() => {
                setStep('Done');
                setSubmitingPayment(false);
                dispatch(getProfileDataThunk());
                dispatch(setNotification(['payment has been successfully confirmed', 'success']));
            })
            .catch(e => {
                setSubmitingPayment(false);
                setErrorMessage(e?.message || xhrDefaultMessage);
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
    };

    return (
        <Modal
            size='sm'
            childClassName={styles.wrapper}
            title={step === 'Done' ? 'Successfull payment' : 'Choose a card to continue'}
            closeFunc={() => dispatch(setExtraServicesPaymentModal(false))}
            icon={step === 'Done' ? <SquareCheckIcon /> : <CreditCardIcon />}
        >
            {step === 'SelectPaymentMethod' && <>
                <span>Your Cards</span>
                {!fetching && paymentMethods?.map(method =>
                    <div className={styles.card} onClick={() => setSelectedMethod(method)}>
                        <CheckBox
                            checked={selectedMethod?.id === method.id}
                            onClick={() => setSelectedMethod(method)}
                        />
                        <div className={styles.card_info}>
                            <span>{method.card.brand}</span>
                            <span>Credit card ending in **** {method.card.last4}</span>
                        </div>
                    </div>)}
                {fetching && <Spinner />}
                <div
                    className={styles.add_new_card}
                    onClick={() => dispatch(setAddNewCardModal(true))}
                >
                    <PlusIcon />
                    <span>Add new credit or debit card</span>
                </div>
            </>}

            {errorMessage && <span className={styles.error}>{errorMessage}</span>}

            {step === 'Done' && <span className={styles.successfull}>
                Your payment has been successfully confirmed.
            </span>}

            <div className={styles.actions}>
                {step === 'SelectPaymentMethod' && <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setExtraServicesPaymentModal(false))}
                />}
                <Button
                    type='Primary'
                    onClick={next}
                    disabled={!selectedMethod}
                    loading={submitingPayment}
                    className={styles.actions_btn}
                    text={step === 'SelectPaymentMethod' ? 'Pay' : 'Confirm'}
                />
            </div>
        </Modal>
    )
};
